"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getModeSpace = void 0;

var _stylesUtils = require("./stylesUtils");

var getModeSpace = function getModeSpace(spacing, mode) {
  return spacing ? (0, _stylesUtils.px)(spacing / (mode === 'dense' ? 2 : 1)) : 0;
};

exports.getModeSpace = getModeSpace;